/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ net: NonNullable<unknown>, fee: NonNullable<unknown> }} Ticketsfeeprevieworganizer3Inputs */

const en_ticketsfeeprevieworganizer3 = /** @type {(inputs: Ticketsfeeprevieworganizer3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You get ${i?.net} per ticket after the ${i?.fee} ticket fee.`)
};

const de_ticketsfeeprevieworganizer3 = /** @type {(inputs: Ticketsfeeprevieworganizer3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du bekommst ${i?.net} pro Ticket, die Ticketgebühr von ${i?.fee} geht ab.`)
};

/**
* | output |
* | --- |
* | "You get {net} per ticket after the {fee} ticket fee." |
*
* @param {Ticketsfeeprevieworganizer3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfeeprevieworganizer3 = /** @type {((inputs: Ticketsfeeprevieworganizer3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfeeprevieworganizer3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfeeprevieworganizer3(inputs)
	return de_ticketsfeeprevieworganizer3(inputs)
});
export { ticketsfeeprevieworganizer3 as "ticketsFeePreviewOrganizer" }